import React from 'react';
import { FeedItem } from './FeedItem';
import { ActionProps, getActivityTypeInfo } from './ActivityFeed';

export const FavoriteAction = (props: ActionProps) => {
  const { activity } = props;
  const { objectType } = activity;
  const info = getActivityTypeInfo(activity)[objectType];

  return (
    <FeedItem
      didWhat={`added ${info.label}`}
      onWhat={{ name: info.name, url: info.path }}
      moreInfo="to your favorites"
    />
  );
};
